export class PelletizingMaterialCost {
    constructor({
          id= null, 
          planCode= ``, 
          locName= ``, 
          day= ``,                   
          shift='',
          materialName= ``,
          materialCode= ``,
          materialBatch= ``,
          moisture= ``,
          level= ``,
          wetWeight= ``,
          dryWeight= ``,
          consumeRate= ``,
          
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.locName = locName;  
      this.day = day;         
      this.shift = shift;  
      this.materialName = materialName;
      this.materialCode = materialCode;
      this.materialBatch = materialBatch;
      this.moisture = moisture;
      this.level = level;
      this.wetWeight = wetWeight;
      this.dryWeight = dryWeight;
      this.consumeRate = consumeRate;
    }
  }
  export function gridFields() {
    return Object.freeze([        
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },                
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },                       
        {
          key: 'materialName',
          label: 'lbl.basic.materialName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'materialCode',
          label: 'lbl.prd.execution.materialCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'materialBatch',
          label: 'lbl.prd.execution.materialBatch',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'moisture',
          label: 'lbl.prd.execution.materialMoisture',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'level',
          label: 'lbl.prd.execution.materialLevel',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'wetWeight',
          label: 'lbl.prd.execution.wetWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'dryWeight',
          label: 'lbl.prd.execution.dryWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'consumeRate',
          label: 'lbl.prd.execution.consumeRate',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new PelletizingMaterialCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',  
    'filter.materialFilter',     
  ];
  export const filter = {
    'planCodeFilter': "", 
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'materialFilter': "",
  };